/* eslint import/prefer-default-export: off */

export function srcPath(path) {
  return (process.env.REACT_APP_DEV_URL || '') + path;
}

export const acceptedFiles =
  // eslint-disable-next-line max-len
  'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.text-template,application/vnd.openofficeorg.extension,application/rtf,text/richtext,application/x-rtf,text/rtf,application/doc';

export function delay(milliseconds) {
  return data =>
    new Promise(resolve => {
      setTimeout(() => resolve(data), milliseconds);
    });
}

/* Code from https://github.com/softonic/axios-retry/blob/master/es/index.js#L25 */
function isRetryableError(error) {
  return (
    error.code !== 'ECONNABORTED' &&
    (!error.response ||
      (error.response.status >= 500 && error.response.status <= 599))
  );
}
/* Code from https://github.com/softonic/axios-retry/blob/master/es/index.js#L9 */
function isNetworkError(error) {
  return (
    !error.response &&
    Boolean(error.code) && // Prevents retrying cancelled requests
    error.code !== 'ECONNABORTED' // Prevents retrying timed out requests
  );
}

export function retryFetch(retries, time, fn) {
  return fn().catch(async err => {
    if ((isRetryableError(err) || isNetworkError(err)) && retries > 1) {
      /* eslint-disable-next-line */
      console.log('Retrying....', retries);
      await delay(3000)();
      retryFetch(retries - 1, time, fn);
    }

    return Promise.reject(err);
  });
}
